import { CollectionProduct } from '../modules/collections/types/collection.types'
import { ColourwayAvailability } from './colourwaySelection'
import { isPurchasableStatus } from './stockUtils'
import { StockStatus } from '../context/ProductDataStore'

export function visibleCollectionProducts(products: CollectionProduct[], current: Record<string, ColourwayAvailability>): CollectionProduct[] {
  return products.filter(product => {
    const availability = current[product.productItemId]
    return product.isAvailableForSale !== false && product.isAvailableInCountry !== false
      && Number.isFinite(product.price) && product.price > 0 && Boolean(availability)
      && (availability.availableForSale === true || ['IN_STOCK', 'LOW_STOCK', 'PREORDER'].includes(availability.stockStatus || ''))
      && isPurchasableStatus(availability.stockStatus as StockStatus | undefined, availability.availableForSale)
  })
}
